import { Link } from "react-router-dom";
import VideoCard from "@/components/base/VideoCard";
import { getLatestVideos } from "@/utils/video";

export default function LatestVideos() {
  const latest = getLatestVideos(6);

  return (
    <div id="latest">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-heading text-2xl font-extrabold text-foreground-950">
            最新视频推荐
          </h2>
          <p className="mt-1.5 text-sm text-foreground-600">刚刚发布与更新的真实生活片段</p>
        </div>
        <Link
          to="/category/daily"
          className="flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
        >
          更多视频 <i className="ri-arrow-right-line" />
        </Link>
      </div>

      {latest.length === 0 ? (
        <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
          <i className="ri-video-line text-4xl text-foreground-400" />
          <p className="mt-3 text-sm text-foreground-600">近期无新视频，敬请期待</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          {latest.map((v, i) => (
            <VideoCard key={v.id} video={v} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}